import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory<HTMLDivElement>()({
  targets: {
    close: HTMLInputElement,
    internal: HTMLInputElement,
  },
  values: { currentlyClosed: Boolean },
}) {
  private dispatchEvent(target: HTMLInputElement) {
    // Dispatching event to trigger all related actions
    const event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    target.dispatchEvent(event);
  }
  internalCheckboxChange() {
    if (!this.currentlyClosedValue && this.internalTarget.checked) {
      this.closeTarget.checked = false;
    }
  }
  toggleClose() {
    this.closeTarget.checked = !this.closeTarget.checked;
    this.dispatchEvent(this.closeTarget);
  }
  toggleInternal() {
    this.internalTarget.checked = !this.internalTarget.checked;
    this.dispatchEvent(this.internalTarget);
  }
}
